import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { DataService } from "../../../@core/services/data.service";
import { BehaviorSubject, Subscription } from "rxjs";
import {
  AvailabilityWeeklySchedule,
  CategoryReservationInterface,
  ReservationInterface,
  SiteNewModel,
} from "../../../@core/models/site-data.model";
import { MatDialog } from "@angular/material/dialog";
import * as Sentry from "@sentry/browser";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ReservationsService } from "../../../@core/services/reservations.service";
import { AnalyticsService } from "../../../@core/services/analytics.service";
import { GoogleAnalyticsService } from "../../../@core/services/google-analytics.service";
import { isPlatformBrowser } from "@angular/common";
import { FontsService } from "src/app/@core/services/fonts.service";


@Component({
  selector: "app-reservation-image",
  templateUrl: "./reservation.component.html",
  styleUrls: ["./reservation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialReservationComponent implements OnInit, OnDestroy {
  title: string;
  text: string;
  picture: string;
  buttonText: string = "Get Started";
  successMsg: string = "";
  buttonsDisplay: number = 0;
  activatePadding: boolean = false;
  displayTiming: boolean = false;
  secondStep: boolean = false;
  noItemFound: boolean = false;
  textColor: string = "";
  backgroundColor: string = "";
  textAlign: string;
  borderRadius: number;
  imagePosition: string;
  subscription: Subscription;
  data: ReservationInterface;
  classBuilder: string = "";
  active: boolean = false;
  position: number = 0;
  party: number = 2;
  dateParty;
  moduleInfo: string;
  isStock: string = "";
  editOn: boolean = false;
  siteId: string = "";
  email: string = "";
  nameReservation: string = "";
  phoneReservation: string = "";
  emailReservation: string = "";
  specialRequestReservation: string = "";
  titleSize: string = "";
  textSize: string = "";
  todayDate: Date = new Date();
  time: string = "";
  dateInputText: string = "";
  partyInputText: string = "";
  selectedTime: string = "";
  selectedCategory: string = "";
  timeInputText: string = "";
  phoneNumberText: string = "";
  fullNameText: string = "";
  emailAddressText: string = "";
  reservationSuccess$: BehaviorSubject<string> = new BehaviorSubject<string>(
    "Failed"
  );
  secondeStepReservationTitle: string = "";
  specialRequestText: string = "";
  secondeStepContactInfoTitle: string = "";
  increment: number;
  closingDays: number[];
  categories: CategoryReservationInterface[];
  timingAvailabilityToday: string[] = [];
  availabilityWeeklySchedule: AvailabilityWeeklySchedule[] = [];
  todayTimingAvailability: AvailabilityWeeklySchedule;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  imageAnimation: string;
  titleColor: string = '';
  fontWeight: string = '';
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(
    private dataService: DataService,
    private _snackBar: MatSnackBar,
    private reservationsService: ReservationsService,
    private analyticsService: AnalyticsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private fontsService:FontsService,
    @Inject(PLATFORM_ID) public platformId
  ) { }
  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.imageAnimation = this.data.animation.image != '' ? this.data.animation.image : undefined;

    }
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "ReservationComponent");
    });
    this.subscription = this.dataService.getSiteId().subscribe((siteId) => {
      this.siteId = siteId;
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.text = this.data.text;
    this.picture = this.data.image;
    this.buttonText = this.data.buttonText;
    this.backgroundColor = this.data.backgroundColor
      ? this.data.backgroundColor
      : "";
    this.borderRadius = this.data.borderRadius;
    this.isStock = this.data.isStock;
    this.textAlign = this.data.textAlign ? this.data.textAlign : "center";
    this.imagePosition = this.data.imagePosition
      ? this.data.imagePosition
      : "right";
    this.titleSize = this.data.titleSize ? this.data.titleSize : "";
    this.textSize = this.data.textSize ? this.data.textSize : "";
    this.buttonsDisplay = this.data.buttonsDisplay;
    this.categories = this.data.categories;
    this.increment = this.data.increment;
    this.availabilityWeeklySchedule = this.data.availabilityWeeklySchedule;
    this.dateInputText = this.data.dateInputText;
    this.partyInputText = this.data.partyInputText;
    this.timeInputText = this.data.timeInputText;
    this.closingDays = this.data.closingDays;
    this.phoneNumberText = this.data.phoneNumberText;
    this.fullNameText = this.data.fullNameText;
    this.emailAddressText = this.data.emailAddressText;
    this.specialRequestText = this.data.specialRequestText;
    this.secondeStepContactInfoTitle = this.data.secondeStepContactInfoTitle;
    this.secondeStepReservationTitle = this.data.secondeStepReservationTitle;
    this.fontWeight = this.data.fontWeight;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.setProperty(
        "--reservation-text",
        this.textColor ? this.textColor : "#fff"
      );
    }
    this.loading = false;
    this.preparAvailabilityWeeklySchedule(new Date());
    this.selectNearTime();
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
  selectTime(timing: string, category: string) {
    this.selectedTime = timing;
    this.selectedCategory = category;
  }
  selectNearTime() {
    this.time = "";
    this.timingAvailabilityToday.forEach((item) => {
      const timeItem = new Date("01/01/2021 " + item);
      const timeTocompare = new Date(
        "01/01/2021 " + this.format24ToAMPM(new Date())
      );
      if (timeItem.getTime() > timeTocompare.getTime() && !this.time) {
        this.time = item;
      }
    });
    if (!this.time && !this.timingAvailabilityToday.includes(this.time)) {
      this.time = this.timingAvailabilityToday[0];
    }
  }
  preparAvailabilityWeeklySchedule(date: Date) {
    this.timingAvailabilityToday = [];
    this.availabilityWeeklySchedule.forEach((element) => {
      if (
        date
          .toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })
          .toLowerCase()
          .includes(element.day.toLowerCase())
      ) {
        element.availability.forEach((item) => {
          this.timingAvailabilityToday = [
            ...this.timingAvailabilityToday,
            ...this.getTimingTable(item.from, item.to, 30),
          ];
        });
      }
    });
  }
  onChangeFimter(type: string) {
    //prepare timing
    this.noItemFound = false;
    let isTheDaySelectedAvailable = true;
    if (type == "dateParty" && this.dateParty && this.closingDays) {
      this.closingDays.forEach((element) => {
        const d1 = new Date(element * 1000);
        const d2 = new Date(this.dateParty);
        if (
          d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getDate() === d2.getDate()
        ) {
          isTheDaySelectedAvailable = false;
          this.noItemFound = true;
        }
      });
    }
    if (this.dateParty && isTheDaySelectedAvailable) {
      this.timingAvailabilityToday = [];
      this.preparAvailabilityWeeklySchedule(new Date(this.dateParty));
      if (type == "dateParty") {
        this.selectNearTime();
      }
      let isTimingFound = false;
      this.categories.forEach((category) => {
        category.timingList = [];
        category.hoursAvailability.forEach((element) => {
          const dateTimingAvailabilityTodayFirstItem = new Date(
            "01/01/2021 " + this.timingAvailabilityToday[0]
          );
          const dateTimingAvailabilityTodayLastItem = new Date(
            "01/01/2021 " +
            this.timingAvailabilityToday[
            this.timingAvailabilityToday.length - 1
            ]
          );
          if (
            dateTimingAvailabilityTodayFirstItem <=
            new Date("01/01/2021 " + element.from) &&
            dateTimingAvailabilityTodayLastItem >=
            new Date("01/01/2021 " + element.to)
          ) {
            category.timingList = [
              ...category.timingList,
              ...this.getTimingTable(element.from, element.to, this.increment),
            ];
          }
        });
        let i = -1;
        category.timingList.forEach((time, index) => {
          const timeDate = new Date("01/01/2021 " + time);
          const selectedTimeDate = new Date("01/01/2021 " + this.time);
          if (selectedTimeDate.getTime() <= timeDate.getTime() && i < 0) {
            i = index;
          }
        });
        category.timingList = category.timingList.slice(i, i + 9);
        if (category.timingList.length > 0) {
          isTimingFound = true;
        }
      });
      this.noItemFound = !isTimingFound;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getTimingTable(timeStart: string, timeEnd: string, increasedBy) {
    increasedBy = increasedBy * 60000;
    let DatetimeStart = new Date(
      "2021-01-01 " + this.formatAMPMTo24(timeStart)
    );
    let DatetimeEnd = new Date("2021-01-01 " + this.formatAMPMTo24(timeEnd));
    let timing = [];
    while (DatetimeStart.getTime() <= DatetimeEnd.getTime()) {
      timing.push(this.format24ToAMPM(DatetimeStart));
      DatetimeStart.setTime(DatetimeStart.getTime() + increasedBy);
    }
    return timing;
  }
  updateUrl($event) {
    const src = $event.target.src;
    $event.target.src = "https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif";
    setTimeout(() => {
      $event.target.src = src;
    }, 8000);
  }
  formatAMPMTo24(time) {
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM == "PM" && hours < 12) hours = hours + 12;
    if (AMPM == "AM" && hours == 12) hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes;
  }
  format24ToAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  nextStep() {
    if (!this.selectedTime) {
      this._snackBar.open("Please select your reservation time", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else if (!this.selectedCategory) {
      this._snackBar.open("Please select your reservation category", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else if (!this.party) {
      this._snackBar.open("Please select your party size", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else if (!this.dateParty) {
      this._snackBar.open("Please choose your party date", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else {
      this.secondStep = true;
    }
  }
  reserveNow() {
    if (!this.nameReservation) {
      this._snackBar.open("Please fill you full name", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else if (
      !this.phoneReservation ||
      !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(
        this.phoneReservation
      )
    ) {
      this._snackBar.open("Please fill you full phone number", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else if (
      !this.emailReservation ||
      !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.emailReservation
      )
    ) {
      this._snackBar.open("Please fill you email", "", {
        duration: 5000,
        verticalPosition: "top",
        horizontalPosition: "center",
        panelClass: ["danger-snackbar"],
      });
    } else {
      let datePartyAsJsDate = new Date(this.dateParty);
      let reservationDate = new Date(
        datePartyAsJsDate.getMonth() +
        1 +
        "-" +
        datePartyAsJsDate.getDate() +
        "-" +
        datePartyAsJsDate.getFullYear() +
        " " +
        this.selectedTime
      );
      this.subscription = this.subscription = this.dataService
        .getCurrentSite()
        .subscribe((site) => {
          this.reservationsService
            .addReservation({
              category: this.selectedCategory,
              specialRequestReservation: this.specialRequestReservation,
              email: this.emailReservation,
              fullName: this.nameReservation,
              phone: this.phoneReservation,
              reservationDate: reservationDate.getTime(),
              siteId: site.siteId,
            })
            .subscribe((data) => {
              this.reservationSuccess$.next("Success");
              this.successMsg =
                "Thanks for your appointment. We'll get back to you soon!";
              const currentSite = this.dataService.site$.getValue();
              if (currentSite) {
                this.analyticsService.trackConversion(currentSite, "click");
              }
              if (currentSite.googleAnalyticsPixel) {
                this.googleAnalyticsService.eventEmitter(
                  "reservation",
                  "reservation",
                  "reservation" + currentSite.email,
                  "contact"
                );
              }
              if (currentSite.facebookPixel) {
                this.googleAnalyticsService.FbEventEmitter(
                  "Reservation",
                  "reservation",
                  "Reservation ",
                  "reservation"
                );
              }
              this._snackBar.open(
                "Thanks for your appointment. We'll get back to you soon!",
                "",
                {
                  duration: 5000,
                  verticalPosition: "top",
                  horizontalPosition: "center",
                  panelClass: ["info-snackbar"],
                }
              );
            });
        });
    }
  }
  displayTimingAction() {
    this.displayTiming = !this.displayTiming;
  }

}
